export class TableSettingsContains {
    public column: string = "";
    public value: string = "";

    constructor(columnP, valueP) {
        this.column = columnP;
        this.value = valueP;
    }
}